import React from "react";
import { CloudOff, CloudUpload, Settings } from "lucide-react";
import { syncOfflineData } from "@/lib/api";
import BrandLogo from "@/components/shared/BrandLogo";

function DashboardHeader({ pendingSync, isOnline }) {
  return (
    <div className="px-4 pt-safe-header pb-3 flex items-center gap-3">

      {/* BRAND */}
      <div className="h-11 w-11 rounded-icon bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 shadow-sm flex items-center justify-center shrink-0">
        <BrandLogo variant="auto" className="h-7 object-contain" />
      </div>

      <div className="flex-1 min-w-0">
        <p className="text-[10px] uppercase tracking-widest text-slate-400 dark:text-slate-500">
          Plataforma pastoral
        </p>
        <h1 className="font-bold text-slate-900 dark:text-slate-100 leading-tight">
          Kéves App
        </h1>
      </div>

      {/* ACTIONS */}
      <div className="flex items-center gap-2 ml-auto shrink-0">

        {pendingSync > 0 && (
          <button
            onClick={() => isOnline && syncOfflineData()}
            className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-[11px] font-semibold border transition-all duration-200 active:scale-[0.97] ${
              isOnline
                ? "bg-slate-50 dark:bg-slate-800/80 text-slate-500 dark:text-slate-400 border-slate-200/80 dark:border-slate-700/60"
                : "bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 border-amber-200 dark:border-amber-800/40"
            }`}
          >
            {isOnline ? (
              <CloudUpload size={13} />
            ) : (
              <CloudOff size={13} />
            )}
            {pendingSync}
          </button>
        )}

        {/* SETTINGS */}
        <button
          onClick={() => window.dispatchEvent(new CustomEvent("keves:openSettings"))}
          aria-label="Configuración"
          className="
            h-11 w-11 rounded-full
            bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700
            shadow-sm
            flex items-center justify-center
            text-slate-500 dark:text-slate-400
            transition-all duration-200 ease-out
            hover:shadow-md hover:text-slate-700 dark:hover:text-slate-200
            active:scale-[0.97]
          "
        >
          <Settings size={16} strokeWidth={2} />
        </button>

      </div>

    </div>
  );
}

export default React.memo(DashboardHeader);
